<template lang="html">
  <transition name="fade">
    <div
      class="modal-pdf bg-color container column justify-content-center align-items-center"
      v-if="show"
    >
      <div
        class="modal-pdf__close container padding-10 justify-content-end"
      >
      <!-- :class="[!pdf ? 'justify-content-end' : 'justify-content-between']" -->
        <!-- <button
          id="back_pdf"
          class="btn btn-sm btn-blue btn-rounded"
          @click="pdf = ''"
          v-if="pdf"
        >
          <font-awesome-icon icon="arrow-left"/>
        </button> -->
        <button
          id="close_pdf"
          class="btn btn-sm btn-blue btn-rounded"
          @click="$store.commit('setShowPdf', false)"
        >
          <font-awesome-icon icon="times"/>
        </button>
      </div>
      <div class="modal-pdf__box flex-grow-1 container wrap" v-if="!pdf">
        <div class="modal-pdf__box__item container column align-items-center justify-content-between padding-10 margin-10">
          <h5 class="margin-bottom-10">Initial Class</h5>
          <button
            class="btn btn-md btn-yellow btn-rounded"
            @click="showPdf('Initial Class Minds.pdf')"
          >
            Read
          </button>
        </div>
        <div class="modal-pdf__box__item container column align-items-center justify-content-between padding-10 margin-10">
          <h5 class="margin-bottom-10">Teaching Guide</h5>
          <button
            class="btn btn-md btn-yellow btn-rounded"
            @click="showPdf('guia de ensino.pdf')"
          >
            Read
          </button>
        </div>
      </div>
      <div class="modal-pdf__box modal-pdf__box--pdf flex-grow-1" v-else>
        <iframe :src="pdfSrc" />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'LoaderModal',
  data () {
    return {
      pdf: 'Initial Class Minds.pdf'
    }
  },
  computed: {
    show () {
      return this.$store.getters['showPdf']
    },
    pdfSrc () {
      if (!this.pdf)
        return ''

      return require(`@/assets/media/${this.pdf}`)
    }
  },
  methods: {
    showPdf (pdf) {
      this.pdf = pdf
    }
  },
  watch: {
    show (val) {
      if (!val)
        this.pdf = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-pdf {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 125;
  &__close {
    width: 100%;
    padding-bottom: 5px;
    button#close_pdf svg,
    button#back_pdf svg {
      font-size: 32px;
    }
  }

  &__box {
    width: calc(100% - 20px);
    border: 5px solid #C2003C;
    border-radius: 15px;
    margin: 10px;
    justify-content: center;
    align-content: baseline;
    &__item {
      background-color: rgba(#FFF, .25);
      border: 5px solid #C2003C;
      border-radius: 15px;
      width: 145px;
      height: 125px;
    }
    &.modal-pdf__box--pdf {
      border: 0;
      iframe {
        width: 100%;
        height: 100%;
      }

      @media(max-width: 524px) {
        width: 100%;
        margin: 0;
        border: none;
        border-radius: 0;
        justify-content: start;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/modalPdf.vue